import { on } from 'delegated-events';
import helpers from './helpers.js';

export default (function () {
  return {
    init() {

      function clearResults() {
        const elements = document.querySelectorAll('.product-search-results');
            

        if (elements) {
          // Disable the button while results are cleared
          const searchButton = document.getElementById('product-search-btn');
          searchButton.disabled = true;   
          helpers.forEach(elements, (i, element) => {
            element.remove();
          });

          document.querySelector('.product-search-results-header').classList.add("u-hide");
          document.querySelector('.product-search-results-clear').classList.add("u-hide");
          document.querySelector('.product-search-results-container').classList.add("u-hide");
          searchButton.disabled = false;
        }
      }

      function clearInput() {
        const inputElement = document.getElementById('product-search-nav');
        if (!inputElement) {
          return;
        }
        if (inputElement.value) {
          inputElement.value='';
        }
      }

      function showExistingNav() {
        document.querySelector('.product-nav-list').classList.remove("u-hide");
      }

      function searchProducts() {
        const inputElement = document.getElementById('product-search-nav');
        if (!inputElement) {
          return;
        }
        clearResults();
        if (inputElement.value) {
          
          const url = `${inputElement.getAttribute('data-ac-url')}/${inputElement.value}`;

          fetch(url, {
            method: 'GET',
          }).then(response => response.json()).then((json) => {
            // hide existing nav
            const productNavList = document.querySelector('.product-nav-list');
            if (productNavList) {
              productNavList.classList.add('u-hide');
            }
            
            const productHeaderContainer = document.querySelector('.product-search-results-container');
            const productResultsHeader = document.querySelector('#product-search-results-header-container');
            if (productResultsHeader) {
              productResultsHeader.classList.remove('u-hide');
            }
            document.querySelector('.product-search-results-header').classList.remove("u-hide");
            document.querySelector('.product-search-results-clear').classList.remove("u-hide");

            if (json.length) {
              // Show results
              
              const productSearchResultsList = document.createElement('ul');

              // insert results after header container
              productHeaderContainer.after(productSearchResultsList);
              

              if (productSearchResultsList) {
                productSearchResultsList.classList.add("opco-nav__sublist", "bare-list", "product-search-results");
                

                helpers.forEach(json, (i, el) => {
                  // Take first ten as some searches have many results
                  if (i < 20) {
                    const resultListItem = document.createElement("li");
                    const resultAnchor = document.createElement("a");
                    const resultSpan = document.createElement("span");
                    resultListItem.classList.add("opco-nav__subitem");
                    resultAnchor.classList.add("opco-nav__sublink");
                    resultSpan.classList.add("opco-nav__subtext");
                    resultListItem.appendChild(resultAnchor);
                    resultAnchor.appendChild(resultSpan);
                    resultSpan.textContent = el.title;
                    resultAnchor.href = el.url;
                    productSearchResultsList.appendChild(resultListItem);
                  }
                });
                
                productHeaderContainer.classList.remove("u-hide");
                productSearchResultsList.classList.remove("u-hide");
              }
            }
            else {
              const noResultsContainer = document.createElement("div");
              noResultsContainer.classList.add("opco-nav__sublist", "bare-list", "product-search-results");
              const noResults = document.createElement("p");
              productHeaderContainer.after(noResultsContainer);
              noResultsContainer.appendChild(noResults);
              noResults.textContent = "No search results found";
              noResults.classList.add("opco-nav__subitem", "search-empty");
            }
          });
        }
      }

      on('click', '.js-product-search-nav', (e) => {
        e.preventDefault();
        searchProducts();
      });

      on('click', '.product-search-results-clear--menu', (e) => {
        e.preventDefault();
        clearResults();
        clearInput();
        showExistingNav();
      });

      on('keypress','#product-search-nav', (e) => {
        // If the user presses the "Enter" key on the keyboard
        if (e.key === "Enter") {
          e.preventDefault();
          // Trigger the button element with a click
          document.querySelector("#product-search-btn").click();
        }
      });
    },
  };
}());
